// KI-Textvorschlaege fuer den Selenny Designer
// Kategorisierte deutsche Textvorschlaege fuer Geburtstag, Hochzeit, Events etc.

const TEXT_SUGGESTIONS = {
  geburtstag: {
    allgemein: [
      'Alles Gute zum Geburtstag!',
      'Happy Birthday!',
      'Herzlichen Glueckwunsch!',
      'Auf dich und dein neues Lebensjahr!',
      'Lass dich feiern!',
      'Heute ist dein Tag!',
      'Feier als gaeb\'s kein Morgen!',
      'Alles Liebe zu deinem Ehrentag!',
      'Hip Hip Hurra!',
      'Ein Hoch auf das Geburtstagskind!',
      'Party on!',
      'Du wirst gefeiert!',
      'Zum Geburtstag viel Glueck!',
      'Auf ein fantastisches neues Jahr!',
    ],
    '18': [
      'Endlich 18 \u2014 die Welt gehoert dir!',
      'Willkommen im Club der Erwachsenen!',
      '18 Jahre und kein bisschen leise!',
      'Ab heute darfst du alles \u2014 ausser alt aussehen!',
      'Volljaerig! Jetzt geht\'s erst richtig los!',
      'Endlich 18 \u2014 auf eigene Gefahr!',
      '18 \u2014 Fuehrerschein, Wahlrecht, Party!',
      'Die Kindheit ist vorbei \u2014 der Spass faengt an!',
      'Erwachsen werden ist optional \u2014 18 werden nicht!',
      'Happy 18! Dein Abenteuer beginnt jetzt!',
    ],
    '20': [
      'Heilige Schnapszahl, du wirst 20!',
      '20 Jahre jung und voller Energie!',
      'Die wilden 20er beginnen!',
      'Zwanzig und bereit fuer alles!',
      '20 \u2014 das beste Jahrzehnt deines Lebens!',
      'Endlich 20 \u2014 Teenager adieu!',
      'Willkommen in den Zwanzigern!',
      'Die 20er sind DEIN Jahrzehnt!',
      '20 Jahre fabelhaft!',
      'Hallo 20, tschuess Pubertaet!',
    ],
    '25': [
      'Vierteljahrhundert \u2014 Respekt!',
      '25 und voller Power!',
      'Happy Silber-Geburtstag!',
      'Ein Vierteljahrhundert pure Lebensfreude!',
      '25 \u2014 die perfekte Mischung aus jung und weise!',
      'Silbernes Jubilaeum des Lebens!',
      '25 Jahre \u2014 und es wird nur besser!',
      'Halbzeit bis 50 \u2014 geniess es!',
    ],
    '30': [
      'Willkommen im Club der Alten!',
      '30 ist das neue 20!',
      'Heilige Schnapszahl, du wirst 30!',
      '30 Jahre \u2014 und es wird nur besser!',
      'Dreissig, flirty und thriving!',
      'Keine Panik \u2014 du bist erst 30!',
      '30 \u2014 jetzt beginnt der Ernst des Lebens. Oder auch nicht!',
      'Endlich 30 \u2014 offiziell erwachsen (theoretisch)!',
      'Die 30er werden legendaer!',
      '30 und immer noch fabelhaft!',
      'Dreissig \u2014 das Leben faengt gerade erst an!',
    ],
    '40': [
      '40 ist das neue 30!',
      'Das Beste kommt jetzt erst!',
      '40 Jahre Erfahrung \u2014 unbezahlbar!',
      'Ab jetzt wird\'s legendaer!',
      'Vierzig \u2014 frech, frei und fantastisch!',
      '40 \u2014 mitten im Leben und mittendrin!',
      'Nicht aelter, nur besser!',
      'Happy 40! Die besten Jahre kommen jetzt!',
      '40 und kein bisschen muede!',
      'Herzlich willkommen im besten Alter!',
    ],
    '50': [
      '50 und kein bisschen leise!',
      'Halbes Jahrhundert \u2014 volle Power!',
      'Die goldenen 50er!',
      '50 ist das neue 40!',
      'Ein halbes Jahrhundert voller Abenteuer!',
      '50 \u2014 die Haelfte geschafft, der Rest wird gefeiert!',
      'Fuenfzig und fabelhaft!',
      '50 Jahre jung \u2014 und kein Ende in Sicht!',
      'Gold-Geburtstag: 50 Jahre!',
      'Halbes Jahrhundert, ganzer Wahnsinn!',
    ],
    '60': [
      '60 Jahre jung!',
      '60 \u2014 und immer noch fabelhaft!',
      'Die wilden Sechziger!',
      '60 ist das neue 50!',
      'Sechzig Jahre voller Leben!',
      '60 und noch lange nicht leise!',
      'Happy 60! Das Abenteuer geht weiter!',
      'Seit 60 Jahren ein Original!',
      '60 \u2014 Erfahrung trifft Lebensfreude!',
      'Herzlichen Glueckwunsch zum 60.!',
    ],
    '70': [
      '70 und immer noch auf der Ueberholspur!',
      'Seit 70 Jahren ein Unikat!',
      '70 \u2014 stolze sieben Jahrzehnte!',
      '70 und kein bisschen langweilig!',
      'Die besten Geschichten erzaehlt man mit 70!',
      'Happy 70! Ein Leben voller Erinnerungen!',
      '70 Jahre Lebensfreude!',
      'Sieben Jahrzehnte \u2014 sieben Gruende zu feiern!',
      '70 ist das neue 60!',
      'Zum 70. nur das Allerbeste!',
    ],
    '80': [
      '80 Jahre \u2014 ein Leben voller Geschichten!',
      'Zum 80. nur das Allerbeste!',
      '80 und immer noch grossartig!',
      'Acht Jahrzehnte voller Leben!',
      '80 \u2014 eine lebende Chronik!',
      'Happy 80! Du bist eine Legende!',
      '80 Jahre Weisheit und Lebensfreude!',
      'Herzlichen Glueckwunsch zum 80. Geburtstag!',
    ],
    '90': [
      '90 Jahre \u2014 eine lebende Legende!',
      'Hut ab vor 90 Jahren!',
      '90 und immer noch unschlagbar!',
      'Neun Jahrzehnte voller Leben!',
      'Zum 90. \u2014 unser groesster Respekt!',
      '90 Jahre \u2014 was fuer eine Reise!',
      'Happy 90! Du bist ein Vorbild!',
      '90 und kein Ende der Lebensfreude!',
    ],
    '100': [
      'Ein ganzes Jahrhundert \u2014 Respekt!',
      '100 Jahre und kein Ende in Sicht!',
      'Herzlichen Glueckwunsch zum 100. Geburtstag!',
      'Ein Jahrhundert voller Geschichten!',
      '100 \u2014 eine Legende feiert!',
      'Drei Ziffern \u2014 unendlich viel Leben!',
      'Happy 100! Ein wahres Wunder!',
      'Hundert Jahre und immer noch fabelhaft!',
    ],
  },
  hochzeit: [
    'Fuer immer und ewig!',
    'Endlich vermaehlt!',
    'Just Married!',
    'Liebe, Lachen, Gluecklichsein!',
    'Zwei Herzen, ein Weg!',
    'Mr. & Mrs.',
    'Ja, ich will!',
    'Heute heiraten wir!',
    'Zusammen ist man weniger allein!',
    'In Liebe vereint!',
    'Bis dass der Tod uns scheidet!',
    'Happily Ever After!',
    'Liebe ist das schoenste Abenteuer!',
    'Love is in the Air!',
    'Gemeinsam in die Zukunft!',
  ],
  jubilaeum: [
    'Herzlichen Glueckwunsch zum Jubilaeum!',
    'Auf die naechsten Jahre!',
    'Gemeinsam stark!',
    'Wir feiern Jubilaeum!',
    'Ein Meilenstein zum Feiern!',
    'Danke fuer die gemeinsame Zeit!',
    'Auf viele weitere Jahre!',
    'Jubilaeum \u2014 Zeit zu feiern!',
    'Tradition trifft Zukunft!',
    'Stolz auf jedes einzelne Jahr!',
  ],
  firmen_event: [
    'Herzlich Willkommen!',
    'Wir feiern gemeinsam!',
    'Danke an unser tolles Team!',
    'Auf gute Zusammenarbeit!',
    'Willkommen zum Firmenevent!',
    'Gemeinsam Grosses erreichen!',
    'Teamwork makes the dream work!',
    'Unser Team \u2014 unsere Staerke!',
    'Danke fuer euren Einsatz!',
    'Zusammen sind wir unschlagbar!',
    'Erfolg ist Teamarbeit!',
    'Let\'s celebrate!',
  ],
  baby: [
    'Willkommen auf der Welt!',
    'Ein Stern ist geboren!',
    'Hello World!',
    'Klein aber oho!',
    'Endlich bist du da!',
    'Willkommen, kleines Wunder!',
    'Es ist ein Maedchen!',
    'Es ist ein Junge!',
    'Baby on Board!',
    'Hurra, du bist da!',
    'Kleines Wunder, grosses Glueck!',
    'Hallo, kleiner Sonnenschein!',
  ],
  abschied: [
    'Wir vermissen dich jetzt schon!',
    'Danke fuer alles!',
    'Auf Wiedersehen & Alles Gute!',
    'Du wirst fehlen!',
    'Mach\'s gut und bis bald!',
    'Danke fuer die schoene Zeit!',
    'Alles Gute fuer die Zukunft!',
    'Tschuess und viel Erfolg!',
    'Neue Wege, neue Abenteuer!',
    'Es war uns eine Ehre!',
  ],
  schulanfang: [
    'Hurra, ich bin ein Schulkind!',
    'Endlich Schule!',
    'Mein erster Schultag!',
    'Auf ins Abenteuer Schule!',
    'Schulkind 2026!',
    'Lesen, Schreiben, Rechnen \u2014 ich komme!',
    'Tschuess Kindergarten, hallo Schule!',
    'Mein grosser Tag!',
  ],
  silvester: [
    'Frohes neues Jahr!',
    'Happy New Year!',
    'Prost Neujahr!',
    'Auf ein tolles neues Jahr!',
    'Neues Jahr, neues Glueck!',
    'Willkommen 2027!',
    'Cheers to the New Year!',
    'Bye bye altes Jahr!',
  ],
  vatertag: [
    'Bester Papa der Welt!',
    'Danke, Papa!',
    'Fuer den tollsten Vater!',
    'Papa, du bist mein Held!',
    'Happy Vatertag!',
    'Super Dad!',
    '#1 Dad',
    'Danke fuer alles, Papa!',
  ],
  muttertag: [
    'Beste Mama der Welt!',
    'Danke, Mama!',
    'Fuer die tollste Mutter!',
    'Mama, du bist wunderbar!',
    'Happy Muttertag!',
    'Super Mom!',
    'Alles Liebe zum Muttertag!',
    'Danke fuer alles, Mama!',
  ],
};

// Kategorie-Labels fuer die UI
const CATEGORY_LABELS = {
  geburtstag: 'Geburtstag',
  hochzeit: 'Hochzeit',
  jubilaeum: 'Jubilaeum',
  firmen_event: 'Firmenevent',
  baby: 'Baby / Geburt',
  abschied: 'Abschied',
  schulanfang: 'Schulanfang',
  silvester: 'Silvester / Neujahr',
  vatertag: 'Vatertag',
  muttertag: 'Muttertag',
};

// Kategorie-Icons fuer die UI
const CATEGORY_ICONS = {
  geburtstag: '\uD83C\uDF82',
  hochzeit: '\uD83D\uDC8D',
  jubilaeum: '\uD83C\uDF89',
  firmen_event: '\uD83C\uDFE2',
  baby: '\uD83D\uDC76',
  abschied: '\uD83D\uDC4B',
  schulanfang: '\uD83C\uDF92',
  silvester: '\uD83C\uDF86',
  vatertag: '\uD83D\uDC68',
  muttertag: '\uD83D\uDC69',
};

/**
 * Erkennt die passende Kategorie basierend auf Texteingabe und Produktname
 * @param {string} text - Aktuelle Texteingabe
 * @param {string} productName - Name des Produkts (aus URL-Parameter)
 * @returns {{ category: string, ageGroup: string|null }}
 */
function detectContext(text, productName = '') {
  const combined = `${text} ${productName}`.toLowerCase();

  // Alter erkennen (Zahl im Text)
  const ageMatch = text.match(/\b(\d{1,3})\b/);
  const detectedAge = ageMatch ? ageMatch[1] : null;

  // Kategorie erkennen
  if (/hochzeit|heirat|braut|vermaeh|trau|married|wedding/i.test(combined)) {
    return { category: 'hochzeit', ageGroup: null };
  }
  if (/baby|geburt|neugebor|taufe|born/i.test(combined)) {
    return { category: 'baby', ageGroup: null };
  }
  if (/schulanfang|einschul|schult/i.test(combined)) {
    return { category: 'schulanfang', ageGroup: null };
  }
  if (/jubilaeum|jubil|anniversary/i.test(combined)) {
    return { category: 'jubilaeum', ageGroup: null };
  }
  if (/firma|firmen|team|event|messe|kongress|unternehmen|company/i.test(combined)) {
    return { category: 'firmen_event', ageGroup: null };
  }
  if (/abschied|tschuess|goodbye|farewell|rente|ruhestand/i.test(combined)) {
    return { category: 'abschied', ageGroup: null };
  }
  if (/silvester|neujahr|new.?year|jahreswechsel/i.test(combined)) {
    return { category: 'silvester', ageGroup: null };
  }
  if (/vatertag|papa|vater|father/i.test(combined)) {
    return { category: 'vatertag', ageGroup: null };
  }
  if (/muttertag|mama|mutter|mother/i.test(combined)) {
    return { category: 'muttertag', ageGroup: null };
  }
  if (/geburtstag|birthday|happy.?b|geb\b/i.test(combined) || detectedAge) {
    return { category: 'geburtstag', ageGroup: detectedAge };
  }

  // Fallback: Geburtstag (haeufigster Anlass)
  return { category: 'geburtstag', ageGroup: null };
}

/**
 * Gibt passende Textvorschlaege zurueck
 * @param {string} text - Aktuelle Texteingabe
 * @param {string} productName - Produktname
 * @returns {string[]}
 */
function getSuggestions(text, productName = '') {
  const { category, ageGroup } = detectContext(text, productName);
  const catData = TEXT_SUGGESTIONS[category];

  if (!catData) return [];

  // Geburtstag: Alters-spezifische + allgemeine Vorschlaege
  if (category === 'geburtstag') {
    const general = catData.allgemein || [];
    if (ageGroup && catData[ageGroup]) {
      return [...catData[ageGroup], ...general];
    }
    return general;
  }

  // Andere Kategorien: einfaches Array
  if (Array.isArray(catData)) {
    return catData;
  }

  return [];
}

export { TEXT_SUGGESTIONS, CATEGORY_LABELS, CATEGORY_ICONS, detectContext, getSuggestions };
export default TEXT_SUGGESTIONS;
